import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/globals.scss";

import { BrowserRouter, Route, Routes } from "react-router-dom";

import AppThemeDesignerPage from "./pages/AppThemeDesignerPage";
import WebThemeDesignerPage from "./pages/WebThemeDesignerPage";
import WelcomePage from "./pages/WelcomePage";
import AppRoutes from "./constants/routes";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path={AppRoutes.OrderApp} element={<AppThemeDesignerPage />} />
          <Route
            path={AppRoutes.OrderAppWL}
            element={<AppThemeDesignerPage isWhiteLabel />}
          />
          <Route
            path={AppRoutes.OrderWebWL}
            element={<WebThemeDesignerPage />}
          />
          <Route path="*" element={<WelcomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
